import { useTranslation } from 'next-i18next/pages'
import { Drawer, Toggle } from 'pcl-ui'
import { track } from 'track'
import { useAppDispatch, useAppSelector } from '@/state/hooks'
import {
  setAskBeforeDiscardingUnsavedChanges,
  setAutoSave,
} from '@/state/reducers'
import { persistor } from '@/state/store'

interface SettingsDrawerProps {
  isOpen: boolean
  onClose: () => void
}

export function SettingsDrawer({ isOpen, onClose }: SettingsDrawerProps) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const askBeforeDiscarding = useAppSelector(
    (state) => state.settings.askBeforeDiscardingUnsavedChanges,
  )
  const autoSave = useAppSelector((state) => state.settings.autoSave)

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title={t('Settings.title')}
      closeLabel={t('Accessibility.closePanel')}
    >
      <div data-test="settings-drawer">
        {process.env.FEATURES_SHOW_ASK_BEFORE_DISCARDING_SETTING === 'true' && (
          <Toggle
            checked={askBeforeDiscarding}
            data-test="ask-before-discarding-toggle"
            onChange={(next) => {
              dispatch(setAskBeforeDiscardingUnsavedChanges(next))
              persistor.flush()
              track('event', 'toggle-ask-before-discarding', {
                event_label: next ? 'on' : 'off',
              })
            }}
            label={t('Settings.askBeforeDiscardingUnsavedChanges')}
          />
        )}
        {process.env.FEATURES_SHOW_AUTO_SAVE_SETTING === 'true' && (
          <Toggle
            checked={autoSave}
            data-test="auto-save-toggle"
            onChange={(next) => {
              dispatch(setAutoSave(next))
              persistor.flush()
              track('event', 'toggle-auto-save', {
                event_label: next ? 'on' : 'off',
              })
            }}
            label={t('Settings.autoSave')}
          />
        )}
      </div>
    </Drawer>
  )
}
